import "./locationCriticalDetailsViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import LocationCriticalDetailsEditComponent
    from "./location-critical-details-edit/locationCriticalDetailsEditComponent";
import LocationCriticalDetailsViewComponent
    from "./location-critical-details-view/locationCriticalDetailsViewComponent";

interface LocationCriticalDetailsViewEditComponentProps {
    locationDetails: any
    onUpdateCriticalDetails: Function;
    onModeChange:Function;
    canEdit: boolean;
}

const LocationCriticalDetailsViewEditComponent = (props: LocationCriticalDetailsViewEditComponentProps) => {
    const {locationDetails, onUpdateCriticalDetails,onModeChange,canEdit} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [locationCriticalDetails, setLocationCriticalDetails] = useState<any>(undefined);

    const handleCriticalDetailsUpdate = useCallback((updatedCriticalDetails: any) => {
        onUpdateCriticalDetails(updatedCriticalDetails);
        setMode("view");
    }, [onUpdateCriticalDetails]);

    const handleCriticalDetailsEditCancel = useCallback(() => {
        setMode("view");
    }, []);

    useEffect(() => {
        if (locationDetails) {
            setLocationCriticalDetails(locationDetails.criticalDetails);
        }
    }, [locationDetails]);

    useEffect(()=>{
        onModeChange(mode)
    },[mode,onModeChange])
    return (
        <div className={'critical-details-view-edit-component details-tab-data-wrapper'}>
            {
                mode === "view" && <LocationCriticalDetailsViewComponent
                    locationCriticalDetails={locationCriticalDetails}
                    canEdit={canEdit}
                    onEditModeOpen={() => {
                        setMode("edit")
                    }}
                />
            }
            {
                mode === "edit" &&
                <LocationCriticalDetailsEditComponent locationCriticalDetails={locationCriticalDetails}
                                                            locationId={locationDetails.id}
                                                            onUpdateComplete={handleCriticalDetailsUpdate}
                                                            onEditCancel={handleCriticalDetailsEditCancel}
                />
            }
        </div>
    );

};

export default LocationCriticalDetailsViewEditComponent;